import {UploadedImages} from '../resources/UploadedImages';
import {DomainEvent} from './DomainEvent';

export class ImagesUploaded extends DomainEvent<UploadedImages> {}
